export enum EntityMappingsType {
	CoBorrowerMappings = 'coBorrowerMappings',
	CoSignerMappings = 'coSignerMappings',
	CreditApplicantMappings = 'creditApplicantMappings',
	TrusteeMappings = 'trusteeMappings',
	GuarantorMappings = 'guarantorMappings',
	AuthorizedSigners = 'authorizedSigners'
}

export const AllEntitiesMappings = [
	EntityMappingsType.CoBorrowerMappings,
	EntityMappingsType.CoSignerMappings,
	EntityMappingsType.CreditApplicantMappings,
	EntityMappingsType.TrusteeMappings,
	EntityMappingsType.GuarantorMappings,
	EntityMappingsType.AuthorizedSigners
];

export const PrimaryEntitiesMappings = [
	EntityMappingsType.CoBorrowerMappings,
	EntityMappingsType.CoSignerMappings,
	EntityMappingsType.CreditApplicantMappings,
	EntityMappingsType.GuarantorMappings
];
